import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { debugPlaybackLog } from '../utils/debugPlayback';

const useScheduledQueue = (device) => {
  const [scheduledQueue, setScheduledQueue] = useState([]);
  const [scheduledMeta, setScheduledMeta] = useState(null);

  const fetchScheduledQueue = useCallback(async () => {
    if (!device?.id) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const res = await axios.get('/api/scheduler/scheduled-runtime', {
        params: { deviceId: device.id },
        headers: { Authorization: `Bearer ${token}` },
      });
      setScheduledQueue(res.data?.queue || []);
      setScheduledMeta(res.data?.scheduled || null);
      debugPlaybackLog('Fetched scheduled runtime queue', {
        deviceId: device.id,
        scheduledId: res.data?.scheduled?.id || null,
        queueLength: res.data?.queue?.length || 0,
      });
    } catch (err) {
      console.error('Failed to fetch scheduled runtime queue', err);
    }
  }, [device?.id]);

  const consumeNext = useCallback(() => {
    setScheduledQueue((prev) => prev.slice(1));
  }, []);

  useEffect(() => {
    fetchScheduledQueue();
  }, [fetchScheduledQueue]);

  return { scheduledQueue, scheduledMeta, fetchScheduledQueue, setScheduledQueue, consumeNext };
};

export default useScheduledQueue;
